import alt from '../alt';


class FlatPageActions {
    constructor() {
        this.generateActions('receivedPages',);
    }

}

export default alt.createActions(FlatPageActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/FlatPageActions.js
 **/